import { Helmet } from "react-helmet-async";
import '../styles/planos.min.css';
import IconPassFlag from '../assets/icon-pass-flag.svg';


export default function Home() {


  return (
    <>
        <Helmet>
            <title>OsteoVitta Pilates - Criciúma</title>
            <link rel="canonical" href="https://www.osteovitta.com.br/planos" />
            <meta name="description" content="Descubra os benefícios do Pilates na OsteoVitta em Criciúma" />
        </Helmet>
        
        <main className='pure-pass-home-pilates'>
            <section className="pilates-pass-pacotes">
                <h2>Conheça nossos planos</h2>
                <span className="pilates-pass-pacotes-subTitle">
                    Escolha o plano que mais se adequa às suas necessidades e ao seu bolso.
                </span>

                <div id="pacotes" className="pilates-pass-pacotes-container">

                    <div className="plano-light-container">
                        <div className="pilates-pass-pacotes-box plano-light">

                            <div className="pilates-pass-pacotes-box--info">
                                <span className="pilates-pass-pacotes-box-name">Plano Mensal 1x - 30 minutos</span>
                                <span className="pilates-pass-pacotes-box-price">
                                    R$ 130 <span className="pilates-pass-pacotes-box-price--grey">/ Mês</span>
                                </span>
                                <span className="pilates-pass-pacotes-box-time">sem fidelidade</span>

                                <a href="https://api.whatsapp.com/send?phone=554891106910&amp;text=Ol%C3%A1,%20estava%20no%20site%20e%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es%20referente%20ao%20plano%20%22Mensal%201x%20-%2030%20minutos%22" target="_blank" title="Clique para Chamar no WhatsApp">
                                    <span className="pilates-pass-pacotes-classes">
                                        1 Aula
                                        <span>/ Semana</span>
                                        <i style={{marginLeft: "10px"}} className="fa fa-whatsapp"></i>
                                    </span> 
                                </a>
                            </div>

                            
                            <hr style={{display: "block", border:"none", height:"1px", background: "#bebebe", marginTop: "15px"}} />

                            <div style={{marginTop:"20px"}} className="pilates-pass-pacotes-box--info">
                                <span className="pilates-pass-pacotes-box-name">Plano Mensal 2x - 30 minutos</span>
                                <span className="pilates-pass-pacotes-box-price">
                                    R$ 225 <span className="pilates-pass-pacotes-box-price--grey">/ Mês</span>
                                </span>
                                <span className="pilates-pass-pacotes-box-time">sem fidelidade</span>
  
                                <a href="https://api.whatsapp.com/send?phone=554891106910&amp;text=Ol%C3%A1,%20estava%20no%20site%20e%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es%20referente%20ao%20plano%20%22Mensal%202x%20-%2030%20minutos%22" target="_blank" title="Clique para Chamar no WhatsApp">
                                    <span className="pilates-pass-pacotes-classes">
                                        2 Aulas
                                        <span>/ Semana</span>
                                        <i style={{marginLeft: "10px"}} className="fa fa-whatsapp"></i>
                                    </span> 
                                </a>
                            </div>

                            <hr style={{display: "block", border:"none", height:"1px", background: "#bebebe", marginTop: "15px"}} />

                            <div style={{marginTop:"20px"}} className="pilates-pass-pacotes-box--info">
                                <span className="pilates-pass-pacotes-box-name">Plano Mensal 3x - 30 minutos</span>
                                <span className="pilates-pass-pacotes-box-price">
                                    R$ 315 <span className="pilates-pass-pacotes-box-price--grey">/ Mês</span>
                                </span>
                                <span className="pilates-pass-pacotes-box-time">sem fidelidade</span>
  
                                <a href="https://api.whatsapp.com/send?phone=554891106910&amp;text=Ol%C3%A1,%20estava%20no%20site%20e%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es%20referente%20ao%20plano%20%22Mensal%203x%20-%2030%20minutos%22" target="_blank" title="Clique para Chamar no WhatsApp">
                                    <span className="pilates-pass-pacotes-classes">
                                        3 Aulas
                                        <span>/ Semana</span>
                                        <i style={{marginLeft: "10px"}} className="fa fa-whatsapp"></i>
                                    </span> 
                                </a>
                            </div>

                        </div>
                    </div>


                    <div className="plano-light-container">
                        <div className="pilates-pass-pacotes-box plano-light">

                            <div className="pilates-pass-pacotes-box--info">
                                <span className="pilates-pass-pacotes-box-name">Plano Mensal 1x - 50 minutos</span>
                                <span className="pilates-pass-pacotes-box-price">
                                    R$ 210 <span className="pilates-pass-pacotes-box-price--grey">/ Mês</span>
                                </span>
                                <span className="pilates-pass-pacotes-box-time">sem fidelidade</span>
  
                                <a href="https://api.whatsapp.com/send?phone=554891106910&amp;text=Ol%C3%A1,%20estava%20no%20site%20e%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es%20referente%20ao%20plano%20%22Mensal%201x%20-%2050%20minutos%22" target="_blank" title="Clique para Chamar no WhatsApp">
                                    <span className="pilates-pass-pacotes-classes">
                                        1 Aula
                                        <span>/ Semana</span>
                                        <i style={{marginLeft: "10px"}} className="fa fa-whatsapp"></i>
                                    </span> 
                                </a>
                            </div>

                            <hr style={{display: "block", border:"none", height:"1px", background: "#bebebe", marginTop: "15px"}} />

                            <div style={{marginTop:"20px"}}  className="pilates-pass-pacotes-box--info">
                                <span className="pilates-pass-pacotes-box-name">Plano Mensal 2x - 50 minutos</span>
                                <span className="pilates-pass-pacotes-box-price">
                                    R$ 320 <span className="pilates-pass-pacotes-box-price--grey">/ Mês</span>
                                </span>
                                <span className="pilates-pass-pacotes-box-time">sem fidelidade</span>
                                
                                <a href="https://api.whatsapp.com/send?phone=554891106910&amp;text=Ol%C3%A1,%20estava%20no%20site%20e%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es%20referente%20ao%20plano%20%22Mensal%202x%20-%2050%20minutos%22" target="_blank" title="Clique para Chamar no WhatsApp">
                                    <span className="pilates-pass-pacotes-classes">
                                        2 Aulas
                                        <span>/ Semana</span>
                                        <i style={{marginLeft: "10px"}} className="fa fa-whatsapp"></i>
                                    </span> 
                                </a>
                            </div>


                            <hr style={{display: "block", border:"none", height:"1px", background: "#bebebe", marginTop: "15px"}} />

                            <div style={{marginTop:"20px"}}  className="pilates-pass-pacotes-box--info">
                                <span className="pilates-pass-pacotes-box-name">Plano Mensal 3x - 50 minutos</span>
                                <span className="pilates-pass-pacotes-box-price">
                                    R$ 420 <span className="pilates-pass-pacotes-box-price--grey">/ Mês</span>
                                </span>
                                <span className="pilates-pass-pacotes-box-time">sem fidelidade</span>
                                
                                <a href="https://api.whatsapp.com/send?phone=554891106910&amp;text=Ol%C3%A1,%20estava%20no%20site%20e%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es%20referente%20ao%20plano%20%22Mensal%202x%20-%2050%20minutos%22" target="_blank" title="Clique para Chamar no WhatsApp">
                                    <span className="pilates-pass-pacotes-classes">
                                        3 Aulas
                                        <span>/ Semana</span>
                                        <i style={{marginLeft: "10px"}} className="fa fa-whatsapp"></i>
                                    </span> 
                                </a>
                            </div>

                        </div>
                    </div>



                    <div className="plano-power-container">
                        <div className="pilates-pass-pacotes-box-flag-box ">
                            <p className="pilates-pass-pacotes-box-flag"> <span>Premium</span></p>
                            <img src={IconPassFlag}/>
                        </div>

                        <div className="pilates-pass-pacotes-box plano-power">

                            <div className="pilates-pass-pacotes-box--info">
                                <span className="pilates-pass-pacotes-box-name">Plano Trimestral 1x - 30 minutos</span>
                                <span className="pilates-pass-pacotes-box-price">
                                    R$ 330 <span className="pilates-pass-pacotes-box-price--grey">/ Total</span>
                                </span>
                                <span className="pilates-pass-pacotes-box-price--black">Benefícios:</span>
                                <span className="pilates-pass-pacotes-box-time">* Ventosaterapia;</span>
                                <span className="pilates-pass-pacotes-box-time">* Laserterapia;</span>
                                <span className="pilates-pass-pacotes-box-time">* 10% de descontos em terapia manual;</span>
                                
                                <a href="https://api.whatsapp.com/send?phone=554891106910&amp;text=Ol%C3%A1,%20estava%20no%20site%20e%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es%20referente%20ao%20plano%20%22Trimestral%20Premium%201x%20-%2030%20minutos%22" target="_blank" title="Clique para Chamar no WhatsApp">
                                    <span className="pilates-pass-pacotes-classes">
                                        1 Aula
                                        <span>/ Semana</span>
                                        <i style={{marginLeft: "10px"}} className="fa fa-whatsapp"></i>
                                    </span> 
                                </a>
                            </div>

                            
                            <hr style={{display: "block", border:"none", height:"1px", background: "#bebebe", marginTop: "13px", marginBottom:"15px"}} />

                            <div className="pilates-pass-pacotes-box--info">
                                <span className="pilates-pass-pacotes-box-name">Plano Trimestral 2x - 30 minutos</span>
                                <span className="pilates-pass-pacotes-box-price">
                                    R$ 585 <span className="pilates-pass-pacotes-box-price--grey">/ Total</span>
                                </span>
                                <span className="pilates-pass-pacotes-box-price--black">Benefícios:</span>
                                <span className="pilates-pass-pacotes-box-time">* Ventosaterapia;</span>
                                <span className="pilates-pass-pacotes-box-time">* Laserterapia;</span>
                                <span className="pilates-pass-pacotes-box-time">* 10% de descontos em terapia manual;</span>
                                
                                <a href="https://api.whatsapp.com/send?phone=554891106910&amp;text=Ol%C3%A1,%20estava%20no%20site%20e%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es%20referente%20ao%20plano%20%22Trimestral%20Premium%202x%20-%2030%20minutos%22" target="_blank" title="Clique para Chamar no WhatsApp">
                                    <span className="pilates-pass-pacotes-classes">
                                        2 Aulas
                                        <span>/ Semana</span>
                                        <i style={{marginLeft: "10px"}} className="fa fa-whatsapp"></i>
                                    </span> 
                                </a>
                            </div>

                        </div>
                    </div>

                    <div className="plano-power-container">
                        <div className="pilates-pass-pacotes-box-flag-box ">
                            <p className="pilates-pass-pacotes-box-flag"> <span>Premium</span></p>
                            <img src={IconPassFlag}/>
                        </div>

                        <div className="pilates-pass-pacotes-box plano-power">

                            <div className="pilates-pass-pacotes-box--info">
                                <span className="pilates-pass-pacotes-box-name">Plano Trimestral 1x - 50 minutos</span>
                                <span className="pilates-pass-pacotes-box-price">
                                    R$ 570 <span className="pilates-pass-pacotes-box-price--grey">/ Total</span>
                                </span>
                                <span className="pilates-pass-pacotes-box-price--black">Benefícios:</span>
                                <span className="pilates-pass-pacotes-box-time">* Ventosaterapia;</span>
                                <span className="pilates-pass-pacotes-box-time">* Laserterapia;</span>
                                <span className="pilates-pass-pacotes-box-time">* 10% de descontos em terapia manual;</span>
                                
                                <a href="https://api.whatsapp.com/send?phone=554891106910&amp;text=Ol%C3%A1,%20estava%20no%20site%20e%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es%20referente%20ao%20plano%20%22Trimestral%20Premium%201x%20-%2050%20minutos%22" target="_blank" title="Clique para Chamar no WhatsApp">
                                    <span className="pilates-pass-pacotes-classes">
                                        1 Aula
                                        <span>/ Semana</span>
                                        <i style={{marginLeft: "10px"}} className="fa fa-whatsapp"></i>
                                    </span> 
                                </a>
                            </div>

                            
                            <hr style={{display: "block", border:"none", height:"1px", background: "#bebebe", marginTop: "13px", marginBottom:"15px"}} />

                            <div className="pilates-pass-pacotes-box--info">
                                <span className="pilates-pass-pacotes-box-name">Plano Trimestral 2x - 50 minutos</span>
                                <span className="pilates-pass-pacotes-box-price">
                                    R$ 900 <span className="pilates-pass-pacotes-box-price--grey">/ Total</span>
                                </span>
                                <span className="pilates-pass-pacotes-box-price--black">Benefícios:</span>
                                <span className="pilates-pass-pacotes-box-time">* Ventosaterapia;</span>
                                <span className="pilates-pass-pacotes-box-time">* Laserterapia;</span>
                                <span className="pilates-pass-pacotes-box-time">* 10% de descontos em terapia manual;</span>
                                
                                <a href="https://api.whatsapp.com/send?phone=554891106910&amp;text=Ol%C3%A1,%20estava%20no%20site%20e%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es%20referente%20ao%20plano%20%22Trimestral%20Premium%202x%20-%2050%20minutos%22" target="_blank" title="Clique para Chamar no WhatsApp">
                                    <span className="pilates-pass-pacotes-classes">
                                        2 Aulas
                                        <span>/ Semana</span>
                                        <i style={{marginLeft: "10px"}} className="fa fa-whatsapp"></i>
                                    </span> 
                                </a>
                            </div>

                        </div>
                    </div>

                    <div className="plano-power-container">
                        <div className="pilates-pass-pacotes-box-flag-box ">
                            <p className="pilates-pass-pacotes-box-flag"> <span>Premium</span></p>
                            <img src={IconPassFlag}/>
                        </div>

                        <div className="pilates-pass-pacotes-box plano-power plano-semestral">

                            <div className="pilates-pass-pacotes-box--info">
                                <span className="pilates-pass-pacotes-box-name">Plano Semestral 1x - 30 minutos</span>
                                <span className="pilates-pass-pacotes-box-price">
                                    R$ 600 <span className="pilates-pass-pacotes-box-price--grey">/ Total</span>
                                </span>
                                <span className="pilates-pass-pacotes-box-price--black">Benefícios:</span>
                                <span className="pilates-pass-pacotes-box-time">* Ventosaterapia;</span>
                                <span className="pilates-pass-pacotes-box-time">* Laserterapia;</span>
                                <span className="pilates-pass-pacotes-box-time">* 10% de descontos em terapia manual;</span>
                                
                                <a href="https://api.whatsapp.com/send?phone=554891106910&amp;text=Ol%C3%A1,%20estava%20no%20site%20e%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es%20referente%20ao%20plano%20%22Semestral%20Premium%201x%20-%2030%20minutos%22" target="_blank" title="Clique para Chamar no WhatsApp">
                                    <span className="pilates-pass-pacotes-classes">
                                        1 Aula
                                        <span>/ Semana</span>
                                        <i style={{marginLeft: "10px"}} className="fa fa-whatsapp"></i>
                                    </span> 
                                </a>
                            </div>

                            
                            <hr style={{display: "block", border:"none", height:"1px", background: "#bebebe", marginTop: "13px", marginBottom:"15px"}} />

                            <div className="pilates-pass-pacotes-box--info">
                                <span className="pilates-pass-pacotes-box-name">Plano Semestral 2x - 30 minutos</span>
                                <span className="pilates-pass-pacotes-box-price">
                                    R$ 1.110 <span className="pilates-pass-pacotes-box-price--grey">/ Total</span>
                                </span>
                                <span className="pilates-pass-pacotes-box-price--black">Benefícios:</span>
                                <span className="pilates-pass-pacotes-box-time">* Ventosaterapia;</span>
                                <span className="pilates-pass-pacotes-box-time">* Laserterapia;</span>
                                <span className="pilates-pass-pacotes-box-time">* 10% de descontos em terapia manual;</span>
                                
                                <a href="https://api.whatsapp.com/send?phone=554891106910&amp;text=Ol%C3%A1,%20estava%20no%20site%20e%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es%20referente%20ao%20plano%20%22Semestral%20Premium%202x%20-%2030%20minutos%22" target="_blank" title="Clique para Chamar no WhatsApp">
                                    <span className="pilates-pass-pacotes-classes">
                                        2 Aulas
                                        <span>/ Semana</span>
                                        <i style={{marginLeft: "10px"}} className="fa fa-whatsapp"></i>
                                    </span> 
                                </a>
                            </div>

                        </div>
                    </div>


                    <div className="plano-power-container">
                        <div className="pilates-pass-pacotes-box-flag-box ">
                            <p className="pilates-pass-pacotes-box-flag"> <span>Premium</span></p>
                            <img src={IconPassFlag}/>
                        </div>

                        <div className="pilates-pass-pacotes-box plano-power plano-semestral">

                            <div className="pilates-pass-pacotes-box--info">
                                <span className="pilates-pass-pacotes-box-name">Plano Semestral 1x - 50 minutos</span>
                                <span className="pilates-pass-pacotes-box-price">
                                    R$ 1.080 <span className="pilates-pass-pacotes-box-price--grey">/ Total</span>
                                </span>
                                <span className="pilates-pass-pacotes-box-price--black">Benefícios:</span>
                                <span className="pilates-pass-pacotes-box-time">* Ventosaterapia;</span>
                                <span className="pilates-pass-pacotes-box-time">* Laserterapia;</span>
                                <span className="pilates-pass-pacotes-box-time">* 10% de descontos em terapia manual;</span>
                                
                                <a href="https://api.whatsapp.com/send?phone=554891106910&amp;text=Ol%C3%A1,%20estava%20no%20site%20e%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es%20referente%20ao%20plano%20%22Semestral%20Premium%201x%20-%2050%20minutos%22" target="_blank" title="Clique para Chamar no WhatsApp">
                                    <span className="pilates-pass-pacotes-classes">
                                        1 Aula
                                        <span>/ Semana</span>
                                        <i style={{marginLeft: "10px"}} className="fa fa-whatsapp"></i>
                                    </span> 
                                </a>
                            </div>

                            
                            <hr style={{display: "block", border:"none", height:"1px", background: "#bebebe", marginTop: "13px", marginBottom:"15px"}} />

                            <div className="pilates-pass-pacotes-box--info">
                                <span className="pilates-pass-pacotes-box-name">Plano Semestral 2x - 50 minutos</span>
                                <span className="pilates-pass-pacotes-box-price">
                                    R$ 1.740 <span className="pilates-pass-pacotes-box-price--grey">/ Total</span>
                                </span>
                                <span className="pilates-pass-pacotes-box-price--black">Benefícios:</span>
                                <span className="pilates-pass-pacotes-box-time">* Ventosaterapia;</span>
                                <span className="pilates-pass-pacotes-box-time">* Laserterapia;</span>
                                <span className="pilates-pass-pacotes-box-time">* 10% de descontos em terapia manual;</span>
                                
                                <a href="https://api.whatsapp.com/send?phone=554891106910&amp;text=Ol%C3%A1,%20estava%20no%20site%20e%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es%20referente%20ao%20plano%20%22Semestral%20Premium%202x%20-%2050%20minutos%22" target="_blank" title="Clique para Chamar no WhatsApp">
                                    <span className="pilates-pass-pacotes-classes">
                                        2 Aulas
                                        <span>/ Semana</span>
                                        <i style={{marginLeft: "10px"}} className="fa fa-whatsapp"></i>
                                    </span> 
                                </a>
                            </div>

                        </div>
                    </div>
                    

                </div>
            </section>

        </main>
    </>
  );
}